import dispatcher from "../dispatcher";
import tabStore from "../tab/tab.store";
import resizeStore from "../resize/resize.store";
import addressStore from "../addressbar/addressbar.store";

var elementProto = Object.create(HTMLElement.prototype);
var isUserScrolling = false;
var scrollTimeout;

var _scrollToTab = function () {
  if (isUserScrolling) return;

  var storeData = tabStore.getData()[this._id];
  if (!storeData) return;

  var index = storeData.index;
  var targetTab = this._tabs[index];
  if (!targetTab) return;

  const y = targetTab.getBoundingClientRect().top + window.scrollY - 90;

  window.scrollTo({ top: y, behavior: "smooth" });
};

var _handleResize = function () {
  var maxH = 0;
  if (this._maxSize) {
    this._tabs.forEach(function (slide) {
      var h = slide.clientHeight;
      maxH = Math.max(maxH, h);
    });
    this.style.height = maxH + "px";
  }
};

var _handleTabVisibility = function () {
  isUserScrolling = true;
  clearTimeout(scrollTimeout);

  scrollTimeout = setTimeout(() => {
    isUserScrolling = false;
  }, 200);

  var closestTab = null;
  var closestDistance = Infinity;

  this._tabs.forEach((tab, index) => {
    var rect = tab.getBoundingClientRect();

    if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
      var distance = Math.abs(rect.top);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestTab = { tab, index };
      }
    }
  });

  if (!closestTab) return;

  var newIndex = this._tabs.indexOf(closestTab.tab);
  if (newIndex !== this._index) {
    this._index = newIndex;
    dispatcher.dispatch({
      type: "tab:to",
      id: this._id,
      index: newIndex,
    });
  }
};

elementProto.createdCallback = function () {
  this._index = 0;
  this.handleResize = _handleResize.bind(this);
  this.handleScroll = _scrollToTab.bind(this);
  this.handleTabVisibility = _handleTabVisibility.bind(this);
};

elementProto.attachedCallback = function () {
  this._id = this.getAttribute("data-id");
  this._maxSize = this.getAttribute("data-maxSize");
  this._tabs = Array.from(this.getElementsByClassName("tab"));
  this.classList.add("initialized");

  dispatcher.dispatch({
    type: "tab:add",
    id: this._id,
    index: this._index,
    total: this._tabs.length,
  });

  this.handleResize();
  this.handleScroll();
  this.handleTabVisibility();

  resizeStore.subscribe(this.handleResize);
  tabStore.subscribe(this.handleScroll);
  document.addEventListener("scroll", this.handleTabVisibility);
};

elementProto.detachedCallback = function () {
  clearTimeout(scrollTimeout);
  resizeStore.unsubscribe(this.handleResize);
  tabStore.unsubscribe(this.handleScroll);
  document.removeEventListener("scroll", this.handleTabVisibility);
};

document.registerElement("tab-scroll", { prototype: elementProto });
